import { render, staticRenderFns } from "./ValuesHistory.vue?vue&type=template&id=4d88e7e9&scoped=true&"
import script from "./ValuesHistory.vue?vue&type=script&lang=ts&"
export * from "./ValuesHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d88e7e9",
  null
  
)

export default component.exports